<template>
  <div>
    <deployment-frequency
      v-if="Array.isArray(releasesOnProdData)"
      :releasesOnProdData="releasesOnProdData"
      :fontSize="fontSize"
    ></deployment-frequency>
    <ReloadIcon v-else></ReloadIcon>
    <lead-time
      :fontSize="fontSize"
    ></lead-time>
  </div>
</template>

<script>
import DeploymentFrequency from '@/views/Metrics/DeploymentFrequency.vue';
import LeadTime from '@/views/Metrics/LeadTime.vue';
import ReloadIcon from '@/views/Metrics/ReloadIcon.vue';
import { createNamespacedHelpers } from 'vuex';
import { getTheSizeOfScreen } from '@/views/Metrics/common/utils';

const { mapState, mapActions } = createNamespacedHelpers('metrics');
export default {
  components: {
    DeploymentFrequency,
    LeadTime,
    ReloadIcon
  },
  data() {
    return {
      fontSize: 18
    };
  },
  computed: {
    ...mapState(['releasesOnProdData'])
  },
  methods: {
    ...mapActions(['getReleasesOnProdData']),
    _resizeScreen: function() {
      let size = getTheSizeOfScreen(window, document),
        screen = {
          width: size[0],
          height: size[1]
        };
      if (screen.width > 899) {
        this.fontSize = 18;
      } else if (screen.width > 799) {
        this.fontSize = 16;
      } else if (screen.width > 699) {
        this.fontSize = 14;
      } else if (screen.width > 599) {
        this.fontSize = 12;
      } else if (screen.width > 499) {
        this.fontSize = 10;
      } else {
        this.fontSize = 10;
      }
    },
    resizeScreen: function() {
      setTimeout(() => {
        try {
          this._resizeScreen();
          window.addEventListener('resize', () => {
            this._resizeScreen();
          });
        } catch (err) {
          this.resizeScreen();
        }
      }, 500);
    }
  },
  mounted: async function() {
    await this.getReleasesOnProdData();
    this.resizeScreen();
  }
};
</script>
